import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { infoButton_template }  from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {imagePicker_template} from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {imageWidget_template} from "./imageWidget_template";

declare var ko: any;

export class configCategoriesEdit_template extends vnTemplate {

    protected selectableCategoriesEditPageTooltip: infoButton_template;
    protected selectableCategoriesEditPageTooltipContent;

    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    protected categoryImageWidget : imageWidget_template
    protected categoryIconWidget : imageWidget_template

    protected getTemplateHtml(): string {

        return `

        <div class="" >
            <div class="form-header">
                <!-- ko if: idCategory() -->
                <h3 class="form-title icon i-category" data-bind="text: name">Edit Category</h3>
                <!-- /ko -->
    
                 <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Category</strong>
                    <div class="form-group">
                        <div class="multi-row">
                            <input id="isSelectable" type="checkbox" data-bind="checked: isSelectable"/>
                            <label for="isSelectable" class="form-label icon i-check">Available for use</label>
                            <div class="w-tooltips-adv pos-bottom short">
                                ` + this.selectableCategoriesEditPageTooltip.getHtmlBuild() + `
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                            <label for="name" class="form-label">Name</label>
                            <input id="name" data-bind="value: name" type="text" class="input-text" disabled>
                        </div>
                </div>

                <div class="form-body">
                    <strong class="form-sub-title">Image</strong>
                        <div class="form-group row">
                        <label class="form-label">Category Image</label>
                    </div>
                
                    <div class="form-group img">
                        ${this.categoryImageWidget.getHtmlBuild()}
                    </div>
                
                    <strong class="form-sub-title">Icon</strong>
                        <div class="form-group row">
                        <label class="form-label">Category Icon</label> 
                    </div>
                
                    <div class="form-group img">
                        ${this.categoryIconWidget.getHtmlBuild()}
                        </div>
                </div>
            </div>   
            
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
        </div>
        ${this.imagePicker.getHtmlBuild()}
            `;
    }

    protected initPartial(): void {

        this.selectableCategoriesEditPageTooltipContent = `
        <p>
        Enabling this will allow this category to be used by a given brand.
        </p>
        `
        this.selectableCategoriesEditPageTooltip = new infoButton_template('selectableCategoriesEditPageTooltip', this.getTemplateViewModel(), this.caller)
        this.selectableCategoriesEditPageTooltip.setTitle('Tag Selection');
        this.selectableCategoriesEditPageTooltip.setContent(this.selectableCategoriesEditPageTooltipContent);

        this.imagePicker = new imagePicker_template("imagePickerCat", this.getTemplateViewModel(), this.caller);

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.categoryImageWidget = new imageWidget_template('category_image', this.getTemplateViewModel(), this);
        this.categoryImageWidget.setMode('single-select');
        this.categoryImageWidget.setCaller(this.imagePickerHelper);


        this.categoryIconWidget = new imageWidget_template('category_icon', this.getTemplateViewModel(), this);
        this.categoryIconWidget.setMode('single-select');
        this.categoryIconWidget.setCaller(this.imagePickerHelper);


    }
    protected getTemplateName(): string {
        return "configCategoriesEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            idCategory: ko.observable(""),
            name: ko.observable(""),
            slug: ko.observable(""),
            description: ko.observable(""),
            isSelectable: ko.observable(0),
            hasSlug: ko.observable(false),
            pinnedTagsIndex: ko.observable(0),
            onClickSave: function (data, event) {
                self.onClickSave();
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        };
    }

    public getViewModelForRequest() {

        return {
            idCategory: this.getTemplateViewModel().idCategory(),
            name: this.getTemplateViewModel().name(),
            slug: this.getTemplateViewModel().slug(),
            description: this.getTemplateViewModel().description(),
            isSelectable: this.getTemplateViewModel().isSelectable(),
            image: this.categoryImageWidget.getImage(),
            iconImage: this.categoryIconWidget.getImage(),
        }
    }

    protected onClickSave() {

        this.caller.save()
    }

    protected onClickCancel() {

        this.caller.cancel();
    }

    public setCategory(data){

        this.getTemplateViewModel().idCategory(data.category.id);
        this.getTemplateViewModel().name(data.category.name);
        this.getTemplateViewModel().description(data.category.details ? data.category.details.description : '');
        this.getTemplateViewModel().isSelectable(data.category.details ? data.category.details.isSelectable : false);

        if(data.category.details && data.category.details.slug){

            this.getTemplateViewModel().slug(data.category.details.slug );
            this.getTemplateViewModel().hasSlug(true);
        }

        const imagePropsAndTargets = [
            { props: 'image', target: 'category_image' },
            { props: 'iconImage', target: 'category_icon' }
        ];

        imagePropsAndTargets.forEach(({ props, target }) => {
            if (data.category.details && data.category.details[props]) {
                this.setImage(data.category.details[props], target)
            }
        });

    }

    public setImage(image, target){
        if(target == 'category_image'){
            this.categoryImageWidget.setImage(image)
        }

        if(target == 'category_icon'){
            this.categoryIconWidget.setImage(image)
        }

    }

}



// WEBPACK FOOTER //
// ./js/components/templates/configCategoriesEdit_template.ts